import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { ShoppingService } from 'src/app/services/shopping.service';
import { filter, pluck, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { StorageService } from 'src/app/services/storage.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { LoginModalComponent } from 'src/app/modals/login-modal/login-modal.component';
@Component({
  selector: 'app-toolbar-home',
  templateUrl: './toolbar-home.component.html',
  styleUrls: ['./toolbar-home.component.scss'],
})
export class ToolbarHomeComponent implements OnInit, OnDestroy {
  private destroyed$ = new Subject<void>();
  @Input() sidenavCheckOut: any;
  @Input() sidenavMenu: any;

  quantityProduct: any = 0;
  readonly canShare = typeof navigator.share === 'function';

  constructor(
    public authService: AuthService,
    private storageService: StorageService,
    private shopping: ShoppingService,
    public router: Router,
    private modal: MatDialog
  ) {}

  async ngOnInit(): Promise<void> {
    this.calculateTotalCart(this.shopping.getShoppingCart());
    const viewCart$ = this.storageService.storageChange$.pipe(
      filter(({ storageArea }) => storageArea === 'sessionStorage'),
      filter(({ key }) => key === 'shoppingCart'),
      pluck('value')
    );

    viewCart$.pipe(takeUntil(this.destroyed$)).subscribe((value) => {
      this.calculateTotalCart(JSON.parse(value));
    });
  }

  calculateTotalCart(viewCart: any) {
    this.quantityProduct = viewCart.reduce(
      (acc: any, item: any) => acc + item.quantity,
      0
    );
    this.quantityProduct =
      this.quantityProduct === 0 ? 0 : this.quantityProduct;
  }

  login() {
    this.modal.open(LoginModalComponent, {
      panelClass: 'ot-dialog-panel',
      data: {},
      disableClose: true,
    });
  }

  get showCart(): boolean {
    return !!this.authService.getUser().uid && /^\/(menus|events)\//.test(this.router.url);
  }

  toggleMenu(): void {
    this.sidenavCheckOut.close();
    this.sidenavMenu.toggle();
  }

  toggleCart(): void {
    this.sidenavMenu.close();
    this.sidenavCheckOut.toggle();
  }

  async share(): Promise<void> {
    if (!this.canShare) return;
    try {
      await navigator.share({ title: document.title, url: window.location.href });
    } catch {
      // Dismissing the system share sheet keeps the current page open.
    }
  }

  refresh(): void { location.reload(); }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
